const state = {
  activeMenu:'/home'
}

const mutations = {
  SET_ACTIVEMENU : (state,path) => {
    state.activeMenu = path
  }
};

const actions = {
  getActiveMenu({state, commit, dispatch},path){

    commit('SET_ACTIVEMENU',path)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
